export default function(state={},action){
    switch(action.type){
        case "GET_USER_SUBSCRIPTION":return {...state,getUserSubscription:action.payload}
        case "SAVE_USER_SUBSCRIPTION":return {...state,saveUserSubscription:action.payload}
       default:
            return state;
    }
}